import * as types from './types'
import storage from '@/Plugins/storage'

export default () => ({
  columns: [
    {
      id: 0,
      name: '# of Activity Sessions',
      code: 'NumActivitySessions',
      order: 'asc',
      sort: 0,
      isFilter: true,
    },
    {
      id: 1,
      name: 'Total Minutes (all zones)',
      code: 'TotalMinutes',
      order: 'asc',
      sort: 1,
      isFilter: true,
    },
    {
      id: 2,
      name: '% of Goal',
      code: 'PercentGoal',
      order: 'asc',
      sort: 2,
      isFilter: true,
    },
    {
      id: 3,
      name: 'Calories',
      code: 'Calories',
      order: 'asc',
      sort: 3,
      isFilter: true,
    },
    {
      id: 4,
      name: 'Meals Tracked',
      code: 'MealsTracked',
      order: 'asc',
      sort: 4,
      isFilter: true,
    },
    {
      id: 5,
      name: 'Nutrition Detail',
      code: 'ThumbsUp',
      order: 'asc',
      sort: 5,
      isFilter: false,
    },
    {
      id: 6,
      name: 'Days Since Last Weight Measurement',
      code: 'DaysLastWeightMeasurement',
      order: 'asc',
      sort: 6,
      isFilter: true,
    },
    {
      id: 7,
      name: 'Weight Change (detailed)',
      code: 'WeightChange',
      order: 'asc',
      sort: 7,
      isFilter: false,
    },
    {
      id: 8,
      name: 'Body Fat Change (detailed)',
      code: 'BodyFatChange',
      order: 'asc',
      sort: 8,
      isFilter: false,
    },
    {
      id: 9,
      name: 'Days Since Last Circumference Measurements',
      code: 'DaysLastSizeMeasurements',
      order: 'asc',
      sort: 9,
      isFilter: true,
    },
    {
      id: 10,
      name: 'Days Since Last Progress Photos',
      code: 'DaysLastPhotos',
      order: 'asc',
      sort: 10,
      isFilter: false,
    },
    {
      id: 11,
      name: 'Training Progress Gauge',
      code: 'TrainingProgressGauge',
      order: 'asc',
      sort: 11,
      isFilter: false,
    },
    {
      id: 12,
      name: 'Training Progress',
      code: 'TrainingProgress',
      order: 'asc',
      sort: 12,
      isFilter: false,
    },
    {
      id: 13,
      name: 'Challenges Week Score',
      code: 'ChallengeWeekScore',
      order: 'asc',
      sort: 13,
      isFilter: true,
    },
    {
      id: 14,
      name: 'Nutrition Up% Progress',
      code: 'MealsProgress',
      order: 'asc',
      sort: 14,
      isFilter: false,
    },
    {
      id: 15,
      name: 'Body Fat Change',
      code: 'BodyFatChange2',
      order: 'asc',
      sort: 15,
      isFilter: false,
    },
    {
      id: 16,
      name: 'Weight Change',
      code: 'WeightChange2',
      order: 'asc',
      sort: 16,
      isFilter: false,
    },
    {
      id: 17,
      name: 'Resources',
      code: 'Resources',
      order: 'asc',
      sort: 17,
      isFilter: false,
    },
    {
      id: 18,
      name: 'NutritionHabits',
      code: 'NutritionHabits',
      order: 'asc',
      sort: 18,
      isFilter: false,
    },
  ],
  summary: null,
  clients: [],
  selected: [],
  members: [],
  member: null,
  memberids: [],
  isAllChecked: false,
  selectedids: [],
  unselectedids: [],
  memberGoals: null,
  memberDailyProgress: null,
  memberProfileHistory: null,
  memberSessionHeartRates: [],
  memberSession: null,
  zoneProfile: null,
  lists: storage.local.getItem(types.STORE_LISTS)
    ? JSON.parse(storage.local.getItem(types.STORE_LISTS))
    : [],
  pager: storage.session.getItem(types.STORE_PAGER)
    ? JSON.parse(storage.session.getItem(types.STORE_PAGER))
    : {
        pageSize: 25,
        orderBy: 'asc',
        sortBy: 'LastName',
        search: null,
        total: 0,
        page: 1,
        pages: 1,
      },
  selectedView: storage.local.getItem(types.STORE_SELECTEDVIEW)
    ? JSON.parse(storage.local.getItem(types.STORE_SELECTEDVIEW))
    : {
        name: '',
        columns: [],
      },
  customViews: [],
  filter: storage.session.getItem(types.STORE_FILTER)
    ? JSON.parse(storage.session.getItem(types.STORE_FILTER))
    : {
        filterAs: null,
        range: {
          limit: null,
          min: 0,
          max: 0,
        },
      },
  challengeStats: null,
})
